import { ThemeUnion } from '@almbrand/systemicons/dist/cjs/types/icon';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { removeItem, selectBasketItems } from 'store/slices/basketSlice';
import { loadBasketJourney } from '../../../services/BasketJourneyService';
import { parseDanishAmount } from '../../../utilities/format';
import { Basket, BasketItem } from '../Basket';

export type QuickBasketProps = {
	themeName: ThemeUnion;
};

export const QuickBasket: React.FC<QuickBasketProps> = ({ themeName }) => {
	const basketItems = useAppSelector(selectBasketItems);
	const dispatch = useAppDispatch();
	const journey = loadBasketJourney();

	const mappedBasketItems: BasketItem[] = basketItems.map((item) => {
		const journeyItem = journey?.items.find(
			(entry) => entry.basketItemId === item.basketItemId && entry.url === item.url
		);
		const result = journeyItem ? journey.results[item.basketItemId] : undefined;
		const parsedPrice = parseDanishAmount(
			result ? result.calculatorForm.SELECTED_PACKAGE_MONTHLY_PRICE?.data?.value : item.price
		);
		return {
			id: item.basketItemId,
			price: Number.isFinite(parsedPrice) && parsedPrice >= 0 ? parsedPrice : undefined,
			deleteBtnLabel: 'Remove',
			editBtnLabel: 'Edit',
			pendingCalculationText: 'Pending calculation',
			detailsBtnLabel: 'Details',
			title: item.name,
			subtitle: result?.selectedPackage ?? item.id,
		};
	});
	const totalAmount = mappedBasketItems.reduce((total, item) => total + (item.price ?? 0), 0);

	return (
		<Basket
			items={mappedBasketItems}
			themeName={themeName}
			addMoreAriaLabel=''
			deleteConfirmationConfirmBtnLabel='Remove'
			deleteConfirmationDescription='Are you sure you want to remove this product?'
			deleteConfirmationTitle='Remove product?'
			existingCustomerTitle='Existing customer'
			summary={{ discountLines: [], totalAmount }}
			onBack={() => console.log('Back')}
			onCheckout={() => console.log('Checkout')}
			summaryCardTotal='Total'
			summaryCardLegalText='Summary Card Legal Text'
			title=''
			onDelete={(id) => dispatch(removeItem(id))}
		/>
	);
};
